var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-root spinner-border",class:("spinner-border-" + _vm.size),attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('general.loading'))+"...")])])}
var staticRenderFns = []

export { render, staticRenderFns }